/**
 * Component Registry for The Deryn
 * 
 * Inherits from @vibesites-axia-residential-arc-living/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-axia-residential-arc-living/theme-preferred/registry';
import { FeeTransparency } from './components/FeeTransparency';
import { FeeTransparencyHero } from './components/FeeTransparencyHero';
import { GuidedTourBox } from './components/GuidedTourBox';
import { Header } from './components/Header';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FeeTransparency,
  FeeTransparencyHero,
  GuidedTourBox,
  Header,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
